module.exports = __webpack_public_path__ + "static/Hero-2be1588023645c630edfca881df3fed2.jpg";